var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.$style.root},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.$t('common.login')))])])}
var staticRenderFns = []

export { render, staticRenderFns }